import type { Action } from 'redux'
import type { StateDefault } from '../../../../../redux/global-store'
import type { ResetPasswordState } from '../../../domain/models/reset-password'
import * as types from '../types/reset-password-types'

export interface ResetPasswordReducerState extends StateDefault {
  resetPasswordFlow: ResetPasswordState
  tokenGenerated: boolean
  tokenValidated: boolean
  resetPasswordCompleted: boolean
  changePasswordCompleted: boolean
}

const initialState: ResetPasswordReducerState = {
  success: false,
  load: false,
  error: '',
  resetPasswordFlow: {
    taxId: '',
    token: '',
    newPin: '',
    confirmPin: '',
  },
  tokenGenerated: false,
  tokenValidated: false,
  resetPasswordCompleted: false,
  changePasswordCompleted: false,
}

export const resetPasswordReducer = (
  state = initialState,
  action: Action & { payload?: any },
) => {
  const newState = { ...state }

  switch (action.type) {
    // Legacy reset password
    case types.USER_RESET_PASSWORD_REQUEST:
      newState.load = true
      newState.error = ''
      return newState

    case types.USER_RESET_PASSWORD_ERROR:
      newState.load = false
      newState.error = action.payload
      return newState

    case types.USER_RESET_PASSWORD_SUCCESS:
      newState.load = false
      newState.resetPasswordCompleted = true
      // Salva o JWT token retornado pelo ResetPassword
      if (action.payload && action.payload.data && action.payload.data.token) {
        newState.resetPasswordFlow = {
          ...newState.resetPasswordFlow,
          jwtToken: action.payload.data.token
        }
      }
      return newState

    case types.USER_RESET_PASSWORD_RESET:
      return initialState

    // Generate Token
    case types.GENERATE_TOKEN_REQUEST:
      newState.load = true
      newState.error = ''
      newState.tokenGenerated = false
      return newState

    case types.GENERATE_TOKEN_SUCCESS:
      newState.load = false
      newState.tokenGenerated = true
      return newState

    case types.GENERATE_TOKEN_ERROR:
      newState.load = false
      newState.error = action.payload
      newState.tokenGenerated = false
      return newState

    // Validate Token
    case types.VALIDATE_TOKEN_REQUEST:
      newState.load = true
      newState.error = ''
      newState.tokenValidated = false
      return newState

    case types.VALIDATE_TOKEN_SUCCESS:
      newState.load = false
      newState.tokenValidated = true
      // Salva o userId da resposta da API
      if (action.payload && action.payload.data && action.payload.data.userId) {
        newState.resetPasswordFlow = {
          ...newState.resetPasswordFlow,
          userId: action.payload.data.userId
        }
      }
      return newState

    case types.VALIDATE_TOKEN_ERROR:
      newState.load = false
      newState.error = action.payload
      newState.tokenValidated = false
      return newState

    // Change Password
    case types.CHANGE_PASSWORD_RESET_REQUEST:
      newState.load = true
      newState.error = ''
      return newState

    case types.CHANGE_PASSWORD_RESET_SUCCESS:
      newState.load = false
      newState.success = true
      newState.changePasswordCompleted = true
      return newState

    case types.CHANGE_PASSWORD_RESET_ERROR:
      newState.load = false
      newState.error = action.payload
      return newState

    // Update State
    case types.RESET_PASSWORD_UPDATE_STATE:
      return {
        ...state,
        resetPasswordFlow: {
          ...state.resetPasswordFlow,
          ...action.payload,
        },
      }

    // Reset State
    case types.RESET_PASSWORD_RESET_STATE:
      return initialState

    default:
      return { ...state }
  }
}

export { initialState as initialStateResetPassword }
